import { api } from './http';

export interface IBuilderAndroidProject {
	id: string;
	label: string;
	dir: string;
}

export async function fetchBuilderProjects() {
	const { data } = await api.get<{ projects: IBuilderAndroidProject[] }>('/builder-projects');
	return data.projects;
}

export const BUILDER_ANDROID_PROJECT_LABELS: Record<string, string> = {
	OmadShou: 'OmadShou (новый)',
	OmadShou_starii: 'OmadShou (старый)',
	OmadShou_starii_no_proguard: 'OmadShou (старый, без ProGuard)',
};

export function getBuilderProjectLabel(dir: string | null | undefined): string | null {
	if (!dir) return null;
	return BUILDER_ANDROID_PROJECT_LABELS[dir] ?? dir;
}
